import { storableError } from '../../util/errors';
import { denormalisedResponseEntities } from '../../util/data';
import { fetchAirplanesMetadata } from '../../modules/airplanes/airplanes.creator';
import { restApiService } from '../../services/services';
import { handleAxiosResponse } from '../../util/apiHelpers';

// ================ Action types ================ //

export const FAVORITES_LISTINGS_REQUEST = 'app/FavoriteWritersPage/FAVORITES_LISTINGS_REQUEST';
export const FAVORITES_LISTINGS_SUCCESS = 'app/FavoriteWritersPage/FAVORITES_LISTINGS_SUCCESS';
export const FAVORITES_LISTINGS_ERROR = 'app/FavoriteWritersPage/FAVORITES_LISTINGS_ERROR';

const SAVED_LISTINGS_CONFIG_IS_OPEN_SET = 'app/FavoriteWritersPage/SAVED_LISTINGS_CONFIG_IS_OPEN_SET';

const RESET_STATE = 'app/FavoriteWritersPage/RESET_STATE';

// ================ Reducer ================ //

const initialState = {
  favoritesListings: [],
  favoritesListingsInProgress: false,
  favoritesListingsError: null,
  pagination: null,
  savedListingsConfigIsOpen: false,
};


const listingPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case FAVORITES_LISTINGS_REQUEST:
      return {
        ...state,
        favoritesListingsInProgress: true,
        favoritesListings: [],
        favoritesListingsError: null,
      };

    case FAVORITES_LISTINGS_SUCCESS:
      return {
        ...state,
        favoritesListings: payload?.listings || [],
        pagination: payload.pagination,
        favoritesListingsInProgress: false,
      };

    case FAVORITES_LISTINGS_ERROR:
      console.error(payload);
      return {
        ...state,
        favoritesListingsInProgress: false,
        favoritesListingsError: payload
      };

    case SAVED_LISTINGS_CONFIG_IS_OPEN_SET:
      return {
        ...state,
        savedListingsConfigIsOpen: payload,
      };

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default listingPageReducer;

// ================ Action creators ================ //

export const favoritesListingsRequest = () => ({
  type: FAVORITES_LISTINGS_REQUEST,
});

export const favoritesListingsSuccess = res => ({
  type: FAVORITES_LISTINGS_SUCCESS,
  payload: res,
});

export const favoritesListingsError = e => ({
  type: FAVORITES_LISTINGS_ERROR,
  error: true,
  payload: e,
});

export const savedListingsConfigIsOpenSetAction = isOpen => ({
  type: SAVED_LISTINGS_CONFIG_IS_OPEN_SET,
  payload: isOpen,
});

export const resetStateAction = () => ({
  type: RESET_STATE,
});

// ================= Selectors ================= //

export const $configModalIsOpen = state => {
  return state.FavoritesPage.savedListingsConfigIsOpen;
};

// ================ Thunks ================ //

export const getListings = search => dispatch => {
  dispatch(favoritesListingsRequest());
  return restApiService.secureInstance
    .getRaw(`savedListings/listings`, { params: Object.fromEntries(new URLSearchParams(search)) })
    .then(handleAxiosResponse)
    .then(res => {
      dispatch(fetchAirplanesMetadata(res.data.data));
      const paginationMeta = res?.data?.meta || {}
      const listings = denormalisedResponseEntities(res);

      const listingsPageData = {
        listings: listings,
        pagination: paginationMeta
      }
      dispatch(favoritesListingsSuccess(listingsPageData));
      return res;
    })
    .catch(e => {
      dispatch(favoritesListingsError(storableError(e)));
      throw e;
    })
  ;
};

export const configModalIsOpenSet = value => dispatch => {
  dispatch(savedListingsConfigIsOpenSetAction(value));
};

export const resetState = () => dispatch => {
  dispatch(resetStateAction());
};

export const loadData = (params, search) => dispatch => {
  return Promise.all([
    dispatch(getListings(search)),
  ]);
};
